import React from 'react';
import { observer } from 'mobx-react-lite';
import '../SelectedHistory.scss';
import { convertAmount, tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';
import { CARDS_TYPE, COMBINATIONS_PAYOUTS } from '../../../enums/cardTypes';
import { cardsStore } from '../../../store/cardsStore';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { selectedCardType } = cardsStore;
  const { data: thirdStepData } = thirdStep;
  const t = useTranslation();

  return (
    <div className='tp-game-history-wrapper'>
      <div className='tp-game-history-inner'>
        {thirdStepData.roundData.finalCards.length && (
          <div className='first-history-cont'>
            <div className={`poker-t-cards-wrp ${selectedCardType}`}>
              {thirdStepData.roundData.initialCards.map(({ card, isHold, index }) => (
                <div key={index} className='poker-t-cards-item-wrp'>
                  <div className='poker-t-cards-item'>
                    <div className={`poker-t-cards-front cursor-default ${CARDS_TYPE[card]}`} />
                    {isHold && <p className='card-held-block'>HELD</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className='history-sm-wrp first-sm'>
          <p className='win-comb-text'>
            {thirdStepData.roundData.winCombination
              ? t(
                  COMBINATIONS_PAYOUTS.find(
                    (item) => item.winType === thirdStepData.roundData.winCombination
                  ).type
                )
              : null}
          </p>
          <div className={`poker-t-cards-wrp ${selectedCardType}`}>
            {(thirdStepData.roundData.finalCards.length
              ? thirdStepData.roundData.finalCards
              : thirdStepData.roundData.initialCards
            ).map(({ card, isWin, index }) => (
              <div key={index} className='poker-t-cards-item-wrp'>
                <div className={`poker-t-cards-item ${isWin ? 'win' : ''}`}>
                  <div className={`poker-t-cards-front cursor-default ${CARDS_TYPE[card]}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className='numb-bottom-holder'>
        <div className='numb-row-history'>
          <div className='numb-cont-his'>
            <p className='numb-cont-his-txt'>{t('BET_AMOUNT')}</p>
          </div>
          <div className='numb-cont-his'>
            <p className='numb-cont-his-txt'>{t('ODD')}</p>
          </div>
          <div className='numb-cont-his'>
            <p className='numb-cont-his-txt'>{t('WIN')}</p>
          </div>
        </div>
        <div className='numb-row-history-bg'>
          <div className='numb-cont-his'>
            <p className='numb-cont-his-txt'>
              {convertAmount(thirdStepData.amount)}{' '}
              {thirdStepData?.freeBetId ? `(${t('FREE_CHIP')})` : ''}
            </p>
          </div>
          <div className='numb-cont-his'>
            <p className='numb-cont-his-txt'>{thirdStepData.odd}</p>
          </div>
          <div className='numb-cont-his'>
            <p className='numb-cont-his-txt active'>
              {thirdStepData.roundData.gambleResults
                ? convertAmount(thirdStepData.roundData.gambleResults[0].amount)
                : convertAmount(thirdStepData.winAmount)}
            </p>
          </div>
        </div>
      </div>

      {thirdStepData.roundData.gambleResults &&
        thirdStepData.roundData.gambleResults.map((item) => (
          <div className='tp-game-history-inner gamble-wrp-pt'>
            <div className='history-sm-wrp'>
              <p className='win-comb-text'>{t('GAMBLE')}</p>
            </div>
            {item.gambleCards.length && (
              <div className='first-history-cont '>
                <div className={`poker-t-cards-wrp ${selectedCardType}`}>
                  {item.gambleCards.map(({ card, isHold, index, isWin }) => (
                    <div key={index} className='poker-t-cards-item-wrp small-cards'>
                      <div
                        className={`poker-t-cards-item ${isWin && index !== 1 ? 'win-gamble' : ''}`}
                      >
                        <div className={`poker-t-cards-front cursor-default ${CARDS_TYPE[card]}`} />
                        {isHold && (
                          <p className='card-held-block'>{index === 1 ? 'DEALER' : 'PICK'}</p>
                        )}
                        {isWin && <div className='bonus-win-block small-cards'>WIN</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className='numb-bottom-holder'>
              <div className='numb-row-history'>
                <div className='numb-cont-his'>
                  <p className='numb-cont-his-txt'>{t('BET_AMOUNT')}</p>
                </div>
                <div className='numb-cont-his'>
                  <p className='numb-cont-his-txt'>{t('ODD')}</p>
                </div>
                <div className='numb-cont-his'>
                  <p className='numb-cont-his-txt'>{t('WIN')}</p>
                </div>
              </div>
              <div className='numb-row-history-bg'>
                <div className='numb-cont-his'>
                  <p className='numb-cont-his-txt'>{convertAmount(item.amount)}</p>
                </div>
                <div className='numb-cont-his'>
                  <p className='numb-cont-his-txt'>{item.odd}</p>
                </div>
                <div className='numb-cont-his'>
                  <p className='numb-cont-his-txt active'>{convertAmount(item.winAmount)}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
});
